var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 99,
    viewBox: "0 0 101 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_225_1060)",
    transform: "translate(0,10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 39,
    r: 37,
    fill: "url(#paint0_linear_225_1060)",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5061 45L63.6496 45C63.9343 45 64.1557 44.7786 64.1557 44.4939L64.1557 37.6934C64.1557 37.4088 64.3771 37.1873 64.6618 37.1873L71.4939 37.1873C71.7786 37.1873 72 36.9659 72 36.6813L72 32.5061C72 32.2214 71.7786 32 71.4939 32L59.5061 32C59.2214 32 59 32.2214 59 32.5061L59 44.4939C59 44.7786 59.253 45 59.5061 45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 29C43.9583 29 46.75 31.7917 46.75 35.25C46.75 38.7083 43.9583 41.5 40.5 41.5C37.0417 41.5 34.25 38.7083 34.25 35.25C34.25 31.7917 37.0417 29 40.5 29ZM53 54H28V51.0833C28 46.9167 36.3333 44.625 40.5 44.625C44.6667 44.625 53 46.9167 53 51.0833V54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4939 24H59.3504C59.0657 24 58.8443 24.2214 58.8443 24.5061V31.3066C58.8443 31.5912 58.6229 31.8127 58.3382 31.8127H51.5061C51.2214 31.8127 51 32.0341 51 32.3187V36.4939C51 36.7786 51.2214 37 51.5061 37H63.4939C63.7786 37 64 36.7786 64 36.4939V24.5061C64 24.2214 63.747 24 63.4939 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_225_1060",
    x: 7,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_225_1060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_225_1060",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_1060",
    x1: 50,
    y1: 4,
    x2: 50,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#71C09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59B18A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdd);
export default __webpack_public_path__ + "static/media/profile-add.d50458dc86c4836b94ee38bc9a40e298.svg";
export { ForwardRef as ReactComponent };